import { trackEvent, gaActions } from './ga4'
import { getUrl } from 'aws-amplify/storage'

export const handleDocumentDownload = (item, gaCategory, customPrefix) => {
  trackEvent({
    action: gaActions.documentClick,
    category: gaCategory,
    label: `${item.model} Documents - ${item.file_name || item.document_title || 'Unknown Document'}`,
  })

  if (!item.is_external_document) {
    return handleDownload(item?.file_path, item?.file_name, customPrefix)
  }
  return handleOpenUrl(item.external_document_url)
}

async function handleDownload(filePath, fileName, customPrefix) {
  const key = `${customPrefix ?? ''}${filePath ?? ''}${fileName ?? ''}`

  const result = await getUrl({
    path: key,
  })
  window.open(result.url.toString(), '_blank')
}

function handleOpenUrl(url) {
  if (!url) {
    return
  }

  window.open(url, '_blank')
}
